import { render, staticRenderFns } from "./UserCardreader.vue?vue&type=template&id=5f268f45&"
import script from "./UserCardreader.vue?vue&type=script&lang=js&"
export * from "./UserCardreader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports